import * as React from "react";
import * as Markdown from 'react-markdown';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export const ExistingDataConflict = ({ configurationWarning }) => {
    const tooltip = <Tooltip id="dataConflictTooltip" style={{ zIndex: 2500 }}>
        <Markdown>{configurationWarning}</Markdown>
    </Tooltip>

    return (
        <>
            {tooltip}
            <FontAwesomeIcon className="text-warning" icon={faTriangleExclamation} data-tooltip-id="dataConflictTooltip" />
        </>
    );
}
